import _ from 'underscore';
import moment from 'moment-timezone';

import * as NewsActions from 'actions/News';

export default function newsReducer(news, action) {
    switch (action.type) {
        case NewsActions.SUCCESS_GET_NEWS:
            return _.map(action.data.news, (n) => {
                return {
                    id: n.id,
                    title: n.title,
                    link: n.link,
                    content: n.content,
                    date: moment.tz(n.date, 'Asia/Bishkek').clone().tz('UTC')
                };
            });
    }

    return news;
}



// WEBPACK FOOTER //
// ./js/sport-betting/reducers/newsReducer.js